var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5b5b5b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "options") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,0A28,28,0,1,0,56,28,28,28,0,0,0,28,0Zm0,54A26,26,0,1,1,54,28,26,26,0,0,1,28,54Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.78,27.66V15.37a.75.75,0,1,0-1.5,0V27.66a3.82,3.82,0,0,0,0,7.49v5.47a.75.75,0,1,0,1.5,0V35.15a3.82,3.82,0,0,0,0-7.49ZM28,33.72a2.31,2.31,0,1,1,2.31-2.31A2.31,2.31,0,0,1,28,33.72Z",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.57,21.36v-6a.75.75,0,1,0-1.5,0v6a3.82,3.82,0,0,0,0,7.49V40.62a.75.75,0,0,0,1.5,0V28.84a3.82,3.82,0,0,0,0-7.48Zm-.75,6.06a2.31,2.31,0,1,1,2.31-2.31A2.31,2.31,0,0,1,18.82,27.41Z",
    transform: "translate(0 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.94,21.36v-6a.75.75,0,1,0-1.5,0v6a3.82,3.82,0,0,0,0,7.49V40.63a.75.75,0,0,0,1.5,0V28.84a3.82,3.82,0,0,0,0-7.48Zm-.75,6.06A2.31,2.31,0,1,1,39.5,25.1,2.31,2.31,0,0,1,37.18,27.41Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.e2dd8008a6a2d0e3b8f5574ef16e61a0.svg";
export { ForwardRef as ReactComponent };